import React from 'react';
import gva from '../img/gva.jpg';
import ldn from '../img/ldn.jpg';
import brest from '../img/brest.jpg';
import nt_main from '../img/nt_main.jpg';
const MyJourney = (props) => 
    { 
    
    

    if (props.lang === "EN") {
        return (
            <div class="content-wrapper">  
            <div>
               I was born in Brest, Belarus, where, owing to my mothers work, from an early age I was exposed to English culture.
               <img src={brest} alt="Brest Belarus" />
            </div>
            <div>
            When I was 20,I moved to London where I spent 10 years building my career, taking on many challenges before focuing 
            on corporate law.
            <img src={ldn} alt="London UK" />
            </div>
             <div>
            After relocating to Switzerland, I realised that I wanted to focus on the legal industry
            , while starting a family and embracing the Swiss way of life. 
            <img src={gva} alt="Geneva Switzerland" />
            </div>
             <div>
             In chasing of all the aspects of success, I realised 
             I was starting to lose myself, and with that the purpose in my life. 
             This forced me to re-evaluate my priorities and 
             change the way I worked and lived. I decided to leave the legal profession and, in the search
             for answers as to why this had happened to me, 
             I immersed myself in the study of psychology and coaching, resulting
             in me becoming my own case.




            
            </div>
             </div>
        );
    } 
    if (props.lang === "RU") {
        return (
            <div class="content-wrapper">  
            <div>
               в разработке
               <img src={brest} alt="Брест Беларусь" />
            </div>
            <div>
          
            <img src={ldn} alt="Лондон Великобритания" />
            </div>
             <div>
       
            <img src={gva} alt="Женева Швейцария" />
            </div>
            
             </div>
        );
    }
}
export default MyJourney;
